import React from "react";
import { CheckIcon } from "../Icons";
import { Pricing, money } from "../business-case/calculator";
import { PromisePanel } from "../ui";

export default function PricingPromise({ pricing }: { pricing: Pricing }) {
  const { promise } = pricing;

  return (
    <section className="tw-bg-white tw-px-8 tw-py-20 sm:tw-px-5 sm:tw-py-12">
      {/* The gutter is the section's, not the card's — CONTAINER's padding would sit inside the
          rounded edge and expose the card background beside the blue panel. */}
      <div className="tw-mx-auto tw-grid tw-max-w-[1180px] tw-grid-cols-[.78fr_1.22fr] tw-overflow-hidden tw-rounded-[30px] tw-border tw-border-[#b9daef] tw-bg-[#eaf6fd] sm:tw-grid-cols-1">
        <PromisePanel>
          {promise.hours} hours
          <br />
          back to your team.
        </PromisePanel>

        <div className="tw-p-12 sm:tw-p-8">
          <h2 className="tw-m-0 tw-max-w-3xl tw-text-3xl tw-font-black tw-leading-[1.12] tw-tracking-[-.035em] tw-text-[#10233f] sm:tw-text-2xl">
            Save at least {promise.hours} hours managing your first mentoring cohort—or we&rsquo;ll refund
            your {money(promise.refund)} standard setup fee.
          </h2>

          <div className="tw-mt-6 tw-grid tw-gap-4 tw-border-t tw-border-[#bfd9e9] tw-pt-6 tw-text-sm tw-leading-6 tw-text-[#304c67]">
            <p className="tw-m-0">
              Available for cohorts of at least {promise.minimumParticipants} participants when FutureLab
              is used across the agreed onboarding, matching, scheduling, engagement-tracking and
              reporting workflow.
            </p>
            <p className="tw-m-0 tw-flex tw-items-start tw-gap-3">
              <CheckIcon aria-hidden className="tw-mt-0.5 tw-h-5 tw-w-5 tw-shrink-0 tw-text-[#16a784]" />
              We agree on the administration baseline with your team before launch, so both sides know
              how the promise will be measured.
            </p>
          </div>

          <p className="tw-mt-5 tw-mb-0 tw-text-xs tw-leading-5 tw-text-[#5c7183]">
            The maximum refund is {money(promise.refund)}. Managed services, external mentor fees, travel,
            customisation and integrations are excluded. Full eligibility and claim terms are confirmed
            in the proposal.
          </p>
        </div>
      </div>
    </section>
  );
}
